import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeProps as _normalizeProps, mergeProps as _mergeProps, withCtx as _withCtx, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  key: 1,
  class: "view"
};
const _hoisted_2 = ["id"];
import { onMounted } from 'vue';
import { createCMap, destroyCMap, toggleAnnotation } from '@/viewModel/cmapUtils.js';
import DataManagerViewModel from '@/viewModel/DataManager/DataManagerViewModel.js';
import { nextTick } from 'vue';
import { TOOLBAR_CONFIG } from '@/components/Toolbar/config';
import { eventBus, toolbarState } from '@/utils/eventBus';
import { useMapStyleStore } from '@/stores/useMapStyleStore';
import { useSystemNameStore } from '@/stores/useSystemNameStore';

import { defineAsyncComponent, ref, shallowRef, provide, watch, computed, onBeforeMount } from 'vue';
import { useRoute, useRouter } from 'vue-router';
const detectRoutePath = '/detect';
export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {
    const mapStyleStore = useMapStyleStore();
    const systemNameStore = useSystemNameStore();
    const Header = defineAsyncComponent(() => import('./views/header/index.vue'));
    const route = useRoute();
    const router = useRouter();
    const initMapFinish = ref(false);
    const mapContainerId = ref('map-container');
    const toolbarTopBtnList = ref([]);
    const toolbarBottomBtnList = ref([]);
    const dataManagerViewModel = shallowRef(null);
    provide('dataManagerViewModel', dataManagerViewModel);
    watch(() => route.path, async (newVal, oldVal) => {
      if (newVal == '/login') {
        await destroyMap();
      } else if (oldVal == '/login' && newVal != '/login') {
        await initMap();
      }
      toggleAnnotation(mapContainerId.value, newVal === detectRoutePath ? 1 : 0);
      toolbarTopBtnList.value = TOOLBAR_CONFIG[newVal]?.topBtnList || [];
      toolbarBottomBtnList.value = TOOLBAR_CONFIG[newVal]?.bottomBtnList || [];
    });
    const showToolBar = computed(() => {
      return initMapFinish.value;
    });
    const isLoginPage = computed(() => {
      return route.path == '/login';
    });
    const showMask = computed(() => {
      return route.path == '/home' || route.path === '/digital-base';
    });
    onBeforeMount(async () => {
      await systemNameStore.getSystemNameByApi();
      systemNameStore.updateSystemName();
    });
    onMounted(() => {
      router.isReady().then(() => {
        if (!isLoginPage.value) {
          initMap();
        }
      });
    });
    const initMap = async () => {
      initMapFinish.value = true;
      await nextTick();
      const cmap = await createCMap(mapContainerId.value);
      toggleAnnotation(mapContainerId.value, route.path === detectRoutePath ? 1 : 0);
      dataManagerViewModel.value = new DataManagerViewModel(cmap.viewer);
    };
    const destroyMap = async () => {
      initMapFinish.value = false;
      await nextTick();
      destroyCMap(mapContainerId.value);
    };
    // 页面工具栏组件映射
    const pageToolbarMap = {
      '/road-network': () => import('@/views/road-network/components/RoadNetworkToolbar.vue'),
      '/apply-fly': () => import('@/views/task-manage/components/TaskManageToolbar.vue'),
      '/grid-management': () => import('@/views/grid-management/legend.vue')
    };
    // 或者在使用时进行类型断言
    const currentPageToolbar = computed(() => {
      const toolbarLoader = pageToolbarMap[route.path];
      return toolbarLoader ? defineAsyncComponent(toolbarLoader) : null;
    });
    // 传递给页面工具栏的属性
    const currentPageToolbarProps = computed(() => {
      // 根据不同页面返回不同的属性
      switch (route.path) {
        case '/road-network':
          return {
            isEditMode: roadNetworkEditMode.value
          };
        case '/apply-fly':
          return {
            isEditMode: taskManageEditMode.value
          };
        default:
          return {};
      }
    });
    // 页面工具栏组件映射
    const pageBottomToolbarMap = {
      '/home': () => import('@/views/home/components/HomeToolbar.vue'),
      '/road-network': () => import('@/views/road-network/components/RoadNetworkBottomToolbar.vue')
    };
    // 或者在使用时进行类型断言
    const currentPageBottomToolbar = computed(() => {
      const toolbarLoader = pageBottomToolbarMap[route.path];
      return toolbarLoader ? defineAsyncComponent(toolbarLoader) : null;
    });
    // 传递给页面工具栏的属性
    const currentPageBottomToolbarProps = computed(() => {
      // 根据不同页面返回不同的属性
      switch (route.path) {
        case '/road-network':
          return {
            isEditMode: roadNetworkEditMode.value
          };
        default:
          return {};
      }
    });
    // 监听任务管理编辑状态变化
    eventBus.on('toolbar:taskManageEditModeChanged', isEdit => {
      taskManageEditMode.value = isEdit;
    });
    const taskManageEditMode = ref(false);
    // 监听路网编辑状态变化
    eventBus.on('toolbar:roadNetworkEditModeChanged', isEdit => {
      roadNetworkEditMode.value = isEdit;
    });
    const roadNetworkEditMode = toolbarState.roadNetworkEditMode;
    const compassVars = computed(() => {
      switch (route.path) {
        case '/home':
          return {
            '--compass-right': '3.65rem'
            // '--compass-bottom': '0.55rem',
          };
        case '/digital-base':
          return {
            '--compass-right': '4.05rem'
            // '--compass-bottom': '0.55rem',
          };
        default:
          return {};
      }
    });
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      const _component_FragmentUpload = _resolveComponent("FragmentUpload");
      const _component_Toolbar = _resolveComponent("Toolbar");
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["app", {
          mask: _unref(showMask)
        }]),
        style: _normalizeStyle(_unref(compassVars))
      }, [!_unref(isLoginPage) ? (_openBlock(), _createBlock(_unref(Header), {
        key: 0
      })) : _createCommentVNode("", true), !_unref(isLoginPage) ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        id: _unref(mapContainerId),
        style: _normalizeStyle(_unref(mapStyleStore).mapContainerStyle)
      }, null, 12, _hoisted_2), _unref(initMapFinish) ? (_openBlock(), _createBlock(_component_router_view, {
        key: 0,
        "map-container-id": _unref(mapContainerId),
        class: "view-content"
      }, null, 8, ["map-container-id"])) : _createCommentVNode("", true), _createVNode(_component_FragmentUpload), _unref(showToolBar) ? (_openBlock(), _createBlock(_component_Toolbar, {
        key: 1,
        "map-container-id": _unref(mapContainerId),
        "top-tool-list": _unref(toolbarTopBtnList),
        "bottom-tool-list": _unref(toolbarBottomBtnList)
      }, {
        topToolAdd: _withCtx(() => [_unref(currentPageToolbar) ? (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(currentPageToolbar)), _normalizeProps(_mergeProps({
          key: 0
        }, _unref(currentPageToolbarProps))), null, 16)) : _createCommentVNode("", true)]),
        bottomToolAdd: _withCtx(() => [_unref(currentPageBottomToolbar) ? (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(currentPageBottomToolbar)), _normalizeProps(_mergeProps({
          key: 0
        }, _unref(currentPageBottomToolbarProps))), null, 16)) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["map-container-id", "top-tool-list", "bottom-tool-list"])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _unref(isLoginPage) ? (_openBlock(), _createBlock(_component_router_view, {
        key: 2,
        class: "view"
      })) : _createCommentVNode("", true)], 6);
    };
  }
});